/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-12 13:47:42
 * @LastEditors: lihuiping lihuiping@yuouhui.com
 * @LastEditTime: 2024-04-10 18:38:15
 * @FilePath: /mzc-frontend-pc/packages/share/use/useRequest.ts
 * @Description:请求数据封装
 *
 */

import axios from "axios";
import apiConfig from "../config/apiConfig";
import { Notice } from "linkd-ui";
import { warning, error, success } from "../components/notice";
import { ref, reactive, watch, unref } from "vue";
import { ElLoading } from "element-plus";
import { useRouter } from "vue-router";
import router from "@/router/index";
import type { ComputedRef, Ref } from "vue";
import localforage from "localforage";

// 获取token
const getToken = () => {
  // 尝试从 localStorage 获取 token 或 cockpit_token（大屏登录使用的key）
  const token: string | null = localStorage.getItem("token") || localStorage.getItem("cockpit_token");
  return token || "";
};

// 请求前拦截
axios.interceptors.request.use(
  (config: Record<string, any>) => {
    let myConfig = config;
    //处理undefined数据
    if (myConfig.data?.toString() == "[object Object]") {
      for (let key in myConfig.data) {
        if (myConfig.data[key] === undefined) {
          myConfig.data[key] = "";
        }
      }
      let tem = JSON.parse(JSON.stringify(myConfig.data));
      myConfig.data = {};
      myConfig.data = tem;
    }
  
    myConfig.headers = {
      "Content-Type": "application/json",
      token: getToken(),
    };
    // 处理formdata
    if (config.type?.toLowerCase() == "formdata") {
      myConfig.headers["Content-Type"] = "multipart/form-data";
    }
    if (myConfig.fileUpload) {
      myConfig.baseURL = config.baseURL || apiConfig.uploadFileUrl; // 网站接口前缀
    } else {
      myConfig.baseURL = config.baseURL || apiConfig.url; // 网站接口前缀
    }
    myConfig.method = "POST";
    if (myConfig.url.indexOf("fileUpload") != -1) {
      myConfig.timeout = 60000 * 5; //5分钟
    } else {
      myConfig.timeout = 50000;
    }

    return myConfig;
  },
  (error) => {
    // 当请求异常时做一些处理
    Notice.open("响应前拦截出错了");
    return Promise.reject(error);
  }
);
interface requestType {
  baseUrl?: string;
  api?: string | Ref<string>;
  method?: string;
  para?: Record<any, any> | Ref<Record<any, any>>;
  manual?: boolean; //手动请求,可以用promise，默认自动
  hasPager?: boolean; //是否有分页，默认没有
  autoGetDataWhenParaChange?: boolean; //数据变化的时候，是否自动请求数据，没有不自动
  preProcess?: Function; //请求过来数据之后，对数据进行预处理,，并返回需要的数据
  afterProcess?: Function; //请求完数据后的操作
  finalProcess?: Function; //请求完走的回调函数
  errorProcess?: Function; //请求错误走的回调函数
  preRequest?: Function; //请求前处理参数
  type?: string; //默认类型
  tip?: boolean; //是否有操作提示，默认没有
  errorTip?: boolean; //是否有错误操作提示，默认有
  noLoading?: boolean; //没有加载，默认有
  maxPageSize?: boolean; //分页size 10000，当列表使用，默认没有
  isBlob?: boolean;
  fileUpload?: boolean;
  noTimeout?: boolean;
  progressCallback?: (a: string) => void;
}
export default function useRequest(option: requestType): any {
  let {
    baseUrl = "",
    api,
    method = "post",
    para = {},
    manual = false,
    fileUpload = false,
    hasPager = false,
    maxPageSize = false,
    noTimeout = false,
    isBlob = false,
    autoGetDataWhenParaChange = false,
    noLoading = false,
    preProcess,
    afterProcess,
    finalProcess,
    errorProcess,
    preRequest,
    type = "json",
    tip = false,
    errorTip = true,
    progressCallback = () => {}, //进度条函数
  } = option;
  const isLoading = ref<boolean>(false);
  let data = ref<Record<string, any> | any[]>(); //获取的数据
  let total = ref(0); //数据总共的条数
  let pager = reactive({
    //分页数据
    pageCurrent: 1,
    pageSize: 20,
  });
  let lastRequestPara: Record<any, any> = {};
  //获取数据
  function getData(_api?: string, _para?: any, isGoPageCurrent1: boolean = true) {
    // const router = useRouter();
    let setting = {
      baseURL: baseUrl,
      fileUpload: fileUpload,
      method,
      url: _api || unref(api),
      // 兜底：para 未传时 unref 后是 undefined，后续 JSON.parse(JSON.stringify(undefined)) 会抛错导致请求发不出去
      data: unref(_para || para) || {},
      type,

      // `onUploadProgress` 允许为上传处理进度事件
      // 浏览器专属
      onUploadProgress: function (progressEvent: any) {
        // 处理原生进度事件
        progressCallback(progressEvent);
      },
    };
    if (type == "json") {
      // 将undefined转换为空字符串,输入组件输入后在清空就是undefined（组件待优化）
      function replaceUndefined(obj: any) {
        for (var key in obj) {
          if (obj.hasOwnProperty(key) && typeof obj[key] === "undefined") {
            obj[key] = "";
          } else if (typeof obj[key] === "object") {
            replaceUndefined(obj[key]);
          }
        }
        return obj;
      }

      setting.data = JSON.parse(JSON.stringify(replaceUndefined(setting.data)));
    }
    if (maxPageSize) {
      pager.pageSize = 10000000;
      hasPager = true;
    }
    if (isGoPageCurrent1) {
      //当点击页码后查询，应该是第一页，重置完搜索条件应该也到第一页
      pager.pageCurrent = 1;
    }
    if (hasPager) {
      setting.data = Object.assign(setting.data, { ...pager });
      pager.pageCurrent = setting.data.pageCurrent;
    }

    if (preRequest) {
      let res: any = preRequest(setting.data);
      if (res) {
        setting.data = res;
      } else {
        return true;
      }
    }
    return new Promise((resolve, reject) => {
      //防止重复请求
      if (unref(para)) {
        //如果初始api在useRequest传递
        if (_para) {
          if (isLoading.value && _para == unref(para)) {
            return reject("重复请求");
          }
        } else {
          //   if (isLoading.value) {
          //     return reject("重复请求")
          //   }
        }
      } else {
        //如果初始api在getData传递
        if (isLoading.value && _para == lastRequestPara) {
          return reject("重复请求");
        }
        if (_para) {
          lastRequestPara = _para;
        }
      }
      isLoading.value = true;

      let loadingInstance: any;
      if (!noLoading && !document.querySelector(".el-loading-spinner .circular")) {
        loadingInstance = ElLoading.service({
          target: (document.body.querySelector("#main_top_content") as any) || (document.querySelector("#main_top_content") as any),
          fullscreen: false,
          background: "transparent",
        });
      }

      //如果当前3级菜单从缓存来到列表页面（在编辑/详情返回的时候不刷新时间戳就是缓存，为了保留用户填写的内容）还是返回到缓存的页码数据
      //如果不是缓存（点击左侧菜单栏）或者是新增  还是要到第一页的
      if (sessionStorage.getItem("goCachePageIndex") && location.href.includes("list")) {
        //如果
        pager.pageCurrent = setting.data.pageCurrent = Number(sessionStorage.getItem("current3LevelMenuCachePageIndex"));
      }

      axios(setting)
        .then((res) => {
          isLoading.value = false;
          if (finalProcess) {
            finalProcess();
          }

          if (isBlob) {
            if (res.data.type == "application/json") {
              reject(res);
            } else {
              const blob = new Blob([res.data]);
              const downloadElement = document.createElement("a");
              const href = window.URL.createObjectURL(blob); //创建下载的链接
              downloadElement.href = href;
              // downloadElement.download = `${filename}.xlsx` //下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); //点击下载
              document.body.removeChild(downloadElement); //下载完成移除元素
              window.URL.revokeObjectURL(href); //释放掉blob对象
              resolve(res.data);
            }
          } else {
            switch (parseInt(res.data.code)) {
              case 200:
                if (!noLoading) {
                  loadingInstance && loadingInstance.close();
                }

                if (location.href.includes("list")&&setting.data.pageCurrent) {
                    sessionStorage.setItem("current3LevelMenuCachePageIndex", setting.data.pageCurrent);
                }
                //编辑/详情页面/或者有的起的名字是add ,其实是编辑的（他没有新增页面，比如分销中心-库存配额-商品库存）,这些页面返回到列表后，列表保持当时的页码状态
                if (location.href.includes("edit") || location.href.includes("view") || (location.href.includes("add") && location.href.includes("&"))) {
                  sessionStorage.setItem("goCachePageIndex", "1");
                } else {
                  sessionStorage.removeItem("goCachePageIndex");
                }

                // setTimeout(() => {
                if (hasPager) {
                  res.data.data.total = Number(res.data.data?.total);
                  total.value = res.data.data?.total;
                }

                if (tip) {
                  if (res.data.message) {
                    success(res.data.message);
                  }
                }

                if (type.toLowerCase() == "formdata") {
                  data.value = res.data;
                  resolve(res.data);
                  if (afterProcess) {
                    afterProcess(res.data);
                  }
                } else {
                  if (preProcess) {
                    res.data.data = preProcess(res.data.data) || res.data.data;
                  }
                  data.value = res.data.data;
                  resolve(res.data.data);
                  if (afterProcess) {
                    afterProcess(res.data.data);
                  }
                }
                // }, 700);

                // res.data.message && success(res.data.message)
                break;
              case 401:
                localStorage.removeItem("token");
                localStorage.removeItem("cockpit_token");
                localforage.clear().then(() => {
                    // 判断是否是大屏页面，如果是则跳转到 大屏登录页
                    if (location.href.includes("/cockpit")) {
                      router.replace({ path: "/login-cockpit" });
                    } else {
                      router.replace({ path: "/login" });
                    }
                  });
                break;
              default:
                if (errorTip) {
                  res.data.message && error(res.data.message);
                }

                if (errorProcess) {
                  errorProcess(res.data.message);
                }

                return reject(setting.url + " api error:" + res.data.message);
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
          isLoading.value = false;

          if (finalProcess) {
            finalProcess();
          }
          if (errorProcess) {
            errorProcess();
          }
          if (err && err.message) {
            error(err.message);
            // if (err.response.status && err.response.status == "401") {
            //   localStorage.clear();
            //   location.reload();
            // }
          }
          // return reject(err)
          return reject(err.message);
        })
        .finally(() => {
          if (!noLoading) {
            loadingInstance && loadingInstance.close();
          }
        });
    });
  }
  //下一页
  function nextPage() {
    if (hasPager) {
      if (Math.ceil(total.value / pager.pageSize) > pager.pageCurrent) {
        changePageIndex(pager.pageCurrent + 1);
      } else {
        console.warn("已经加载完所有分页的数据了");
      }
    }
  }
  //改变页码
  function changePageIndex(page: number = 1, isForce: boolean = false) {
    if (page !== pager.pageCurrent) {
      pager.pageCurrent = page;
      getData("", null, false);
    } else if (isForce) {
      getData("", null, false);
    }
  }
  //改变分页数据
  function changePageSize(s: number = 15, isForce: boolean = false) {
    if (isForce) {
      pager.pageSize = s;
      changePageIndex(1, true);
    } else {
      if (s !== pager.pageSize) {
        pager.pageSize = s;
        changePageIndex(1, true);
      }
    }
  }
  //监控参数变化，并自动发送请求
  watch(
    () => option.para,
    (prev, now) => {
      if (autoGetDataWhenParaChange === true) {
        if (hasPager) {
          changePageIndex(1, true);
        } else {
          getData("", null, false);
        }
      }
    },
    { deep: true }
  );

  //如果手动请求，不自动获取数据
  if (!manual) {
    getData("", null, false);
  }

  return {
    isLoading,
    data,
    pager,
    total,
    getData,
    changePageIndex,
    changePageSize,
    nextPage,
  };
}
